<script>
import SnackbarContainer from './components/SnackBar/Container.vue';

export default {
  components: { SnackbarContainer },
  data() {
    return { theme: 'light' };
  },
  mounted() {
    this.setColorTheme();
    this.listenToThemeChanges();
    this.setLocale(window.chatwootConfig.selectedLocale);
    window.addEventListener('crow-theme-toggle', this.applyManualTheme);
  },
  beforeUnmount() {
    window.removeEventListener('crow-theme-toggle', this.applyManualTheme);
  },
  methods: {
    applyManualTheme(e) {
      const next = e && e.detail === 'dark' ? 'dark' : 'light';
      this.theme = next;
      if (next === 'dark') {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    },
    setColorTheme() {
      if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        this.theme = 'dark';
        document.documentElement.classList.add('dark');
      } else {
        this.theme = 'light';
        document.documentElement.classList.remove('dark');
      }
    },
    listenToThemeChanges() {
      const mql = window.matchMedia('(prefers-color-scheme: dark)');

      mql.onchange = e => {
        if (e.matches) {
          this.theme = 'dark';
          document.documentElement.classList.add('dark');
        } else {
          this.theme = 'light';
          document.documentElement.classList.remove('dark');
        }
      };
    },
    setLocale(locale) {
      if (locale) {
        this.$root.$i18n.locale = locale;
      }
    },
  },
};
</script>

<template>
  <div class="h-full min-h-screen w-full antialiased" :class="theme">
    <router-view />
    <SnackbarContainer />
  </div>
</template>

<style lang="scss">
@tailwind base;
@tailwind components;
@tailwind utilities;

@import '../dashboard/assets/scss/next-colors';

html,
body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', sans-serif;
  @apply h-full w-full;

  input,
  select {
    outline: none;
  }
}

.text-link {
  @apply text-n-brand font-medium hover:text-n-blue-10;
}

// Crow custom: primary solid buttons use the email gradient on v3/auth screens
.bg-n-brand,
.bg-woot-500,
.bg-woot-600,
button.button.success,
.button--primary {
  background-image: linear-gradient(
    135deg,
    #a855f7 0%,
    #7c3aed 25%,
    #6366f1 75%,
    #3b82f6 100%
  ) !important;
  background-color: #6366f1 !important;
  border-color: transparent !important;
  color: white !important;
}

.bg-n-brand:hover,
.bg-woot-500:hover,
.bg-woot-600:hover,
button.button.success:hover,
.button--primary:hover {
  filter: brightness(1.08);
}

.v-popper--theme-tooltip .v-popper__inner {
  background: black !important;
  font-size: 0.75rem;
  padding: 4px 8px !important;
  border-radius: 6px;
  font-weight: 400;
}

.v-popper--theme-tooltip .v-popper__arrow-container {
  display: none;
}
</style>
